import { DataFrame } from '../../data/DataFrame';
import { DataFrameService, MemoryDataService } from '../../service';
import { BufferNode } from './BufferNode';
/**
 * @category Flow shape
 */
export class MemoryBufferNode extends BufferNode {
  constructor(options) {
    super(options);
    this.service = new DataFrameService(new MemoryDataService(DataFrame, {
      serialize: d => d,
      deserialize: d => d
    }));
  }
}